module.exports = __webpack_public_path__ + "static/media/kathy_yen.f1b1e992.jpg";